import API from 'services/api';
import { ISelectModel } from 'common/models/ISelectModel';

export const getOccupancyPartners = (): Promise<ISelectModel<string>[]> =>
  API.get('/api/accommodation/occupancy-partners').then(response => response?.data);
